const UNIT = {
  PRICE: 'تومان',
  WIDTH: 'سانتی‌متر',
  WEIGHT: 'گرم',
} as const;

export { UNIT };
